































import { Component, Prop, Vue } from "vue-property-decorator";
import { api } from "@/api";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";

@Component
export default class CreateWorkingOnIssue extends Vue {
  @Prop(String) readonly label!: string;
  dialog = false;
  addTitle = "";
  description = "";

  private async save() {
    const gitLabInfo = readGitLabInfo(this.$store);
    try {
      const response = await api.createNewWorkingOnIssue(
        gitLabInfo.projectId,
        this.label,
        this.addTitle,
        this.description
      );
      this.dialog = false;
      this.$emit("reloadIssues");
    } catch (e) {
      await dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Unable to create new Issue:<br>${e}`)
      );
    }
  }
}
